export const EMPLOYEES = "employees"
export const ASSETS = "assets"
export const JOBS = "jobs"
export const TENANTS = "tenants"
export const USERS = "users"